// extracted by mini-css-extract-plugin
module.exports = {"EntireHeaderBox":"Header_EntireHeaderBox__30yhI","Heading":"Header_Heading__UOxNH"};